import ReactTable from "react-table";
import * as React from "react";
import {PropsWithChildren} from "react";
import {Foerdernehmertype} from "./ReactDropDown";

interface Props {
    foerderungen: Foerdernehmertype[]

};

let columns = [{
    Header: 'Fördernehmer',
    accessor: 'foerdernehmer'
},{
    Header: 'Name',
    accessor: 'name'
},{
    Header: 'Datum',
    accessor: 'datum'
}]
export default class ReactFoerder extends React.Component<PropsWithChildren<Props>> {
    constructor(props: Props) {

        super(props);
        this.state = {checked: false};
    }

    render() {
        return (

            <div>
                {this.props.foerderungen.map(function(overlay){
                    return <div>
     
                        <text className="anbietervalue">{overlay.foerdernehmer} </text>
                        <text className="anbietervalue">{overlay.datum}</text>
                </div>
                })}
            </div>

        );
    }
}
